import type { Direction } from '@mui/material/styles';

import { useEffect } from 'react';
import createCache from '@emotion/cache';
import rtlPlugin from 'stylis-plugin-rtl';
import { CacheProvider } from '@emotion/react';

// ----------------------------------------------------------------------

type RtlProps = {
  direction: Direction;
  children: React.ReactNode;
};

const cacheRtl = () =>
  createCache({
    key: 'rtl',
    prepend: true,
    stylisPlugins: [rtlPlugin],
  });

export function Rtl({ children, direction }: RtlProps) {
  useEffect(() => {
    document.dir = direction;
  }, [direction]);

  if (direction === 'rtl') {
    return <CacheProvider value={cacheRtl()}>{children}</CacheProvider>;
  }

  return <>{children}</>;
}
